// Comportamenti custom del tema. Ogni blocco si aggancia a una pagina precisa
// e non fa nulla altrove: il file viene caricato ovunque, come custom.css.

(function () {
  "use strict";

  // --------------------------------------------------------------------------
  // Pagina Atelier — "Experience" come accordion sotto i 60em.
  //
  // Sul frame mobile del Figma (666:138) le due colonne della sezione sono due
  // righe apribili: filetto, etichetta ("in atelier" / "da remoto") e "+".
  // L'etichetta non e un campo a se: e la prima casella delle "Righe meta"
  // della colonna, quindi si legge da li (vedi accordionLabel).
  //
  // Il DOM non viene ristrutturato: si antepone il bottone alla colonna e si
  // marca la colonna come chiusa. Tutto il resto lo nasconde il CSS, che sopra
  // i 60em tiene il bottone a display:none e lascia il desktop intatto.
  // --------------------------------------------------------------------------
  var ACCORDION_SECTION =
    '[data-section-type="text-columns-with-images"].collection-list-grid--columns-2';

  function setAccordionState(feature, open) {
    var header = feature.querySelector(".atelier-accordion__header");
    var icon = feature.querySelector(".atelier-accordion__icon");

    feature.setAttribute("data-atelier-accordion", open ? "open" : "closed");
    if (header) header.setAttribute("aria-expanded", open ? "true" : "false");
    if (icon) icon.textContent = open ? "–" : "+";
  }

  // L'etichetta della riga e la prima casella compilata delle "Righe meta" del
  // blocco. Le colonne scritte alla vecchia maniera non hanno quei campi: li
  // l'etichetta resta la prima voce dell'elenco dentro al testo.
  function accordionLabel(feature) {
    var cells = feature.querySelectorAll(".text-columns__meta-item");

    for (var i = 0; i < cells.length; i++) {
      var value = cells[i].textContent.trim();
      if (value) return value;
    }

    var firstItem = feature.querySelector(".text-block__subheading ul li");
    return firstItem ? firstItem.textContent.trim() : "";
  }

  function buildExperienceAccordion(root) {
    var page = root.classList && root.classList.contains("atelier-page")
      ? root
      : root.querySelector(".atelier-page") || document.querySelector(".atelier-page");
    if (!page) return;

    var section = root.matches && root.matches(ACCORDION_SECTION)
      ? root
      : root.querySelector(ACCORDION_SECTION);
    if (!section || !page.contains(section)) return;

    var features = section.querySelectorAll(".text-columns__feature");

    Array.prototype.forEach.call(features, function (feature) {
      if (feature.querySelector(".atelier-accordion__header")) return;

      var label = accordionLabel(feature);
      if (!label) return;

      var header = document.createElement("button");
      header.type = "button";
      header.className = "atelier-accordion__header";
      header.setAttribute("aria-expanded", "false");

      var text = document.createElement("span");
      text.className = "atelier-accordion__label";
      text.textContent = label;

      var icon = document.createElement("span");
      icon.className = "atelier-accordion__icon";
      icon.setAttribute("aria-hidden", "true");
      icon.textContent = "+";

      header.appendChild(text);
      header.appendChild(icon);

      feature.setAttribute("data-atelier-accordion", "closed");
      feature.insertBefore(header, feature.firstChild);

      // Uno alla volta: aprendone uno, l'altro si chiude.
      header.addEventListener("click", function () {
        var willOpen = feature.getAttribute("data-atelier-accordion") !== "open";
        var others = section.querySelectorAll("[data-atelier-accordion]");

        Array.prototype.forEach.call(others, function (other) {
          if (other !== feature) setAccordionState(other, false);
        });

        setAccordionState(feature, willOpen);
      });
    });
  }

  // --------------------------------------------------------------------------
  // Pagina Atelier — il mosaico come carosello sotto i 60em.
  //
  // Sul frame mobile scorre in orizzontale come le sezioni gallery, che il tema
  // monta su Flickity (assets/theme.js, funzione carousel). mosaic-grid non ha
  // quella registrazione, quindi il carosello va avviato a mano: stesso
  // Flickity, preso dal chunk che il tema pubblica su window.flu.chunks, e
  // stesse opzioni, copiate da li.
  //
  // Tipologie ed Editorial non passano di qui: sotto i 60em sono due sezioni
  // gallery vere ("tipologie-gallery", "editorial-gallery"), quindi il carosello
  // se lo monta il tema.
  //
  // Se Flickity non si carica non si rompe niente: il CSS lascia i contenitori
  // in overflow-x auto, quindi restano comunque scorribili.
  // --------------------------------------------------------------------------
  var CAROUSEL_SELECTORS = ['[data-section-type="mosaic-grid"] .mosaic-grid__grid'];

  var CAROUSEL_OPTIONS = {
    adaptiveHeight: false,
    wrapAround: false,
    contain: true,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    initialIndex: 0,
    dragThreshold: 1
  };

  var MOBILE = "(max-width: 60em)";
  var flickityPromise = null;
  var dynamicImport = null;

  // import() sta dentro new Function apposta: se il browser non lo supporta
  // fallisce solo questa riga, invece di rendere illeggibile tutto il file.
  try {
    dynamicImport = new Function("url", "return import(url);");
  } catch (error) {
    dynamicImport = null;
  }

  function loadFlickity() {
    if (!dynamicImport) return Promise.reject();
    if (!window.flu || !window.flu.chunks || !window.flu.chunks.flickity) {
      return Promise.reject();
    }
    if (!flickityPromise) flickityPromise = dynamicImport(window.flu.chunks.flickity);
    return flickityPromise;
  }

  function carouselNodes() {
    var page = document.querySelector(".atelier-page");
    if (!page) return [];

    var nodes = [];
    CAROUSEL_SELECTORS.forEach(function (selector) {
      var node = page.querySelector(selector);
      if (node && node.children.length > 1) nodes.push(node);
    });
    return nodes;
  }

  function syncCarousels() {
    var nodes = carouselNodes();
    if (!nodes.length) return;

    if (!window.matchMedia(MOBILE).matches) {
      nodes.forEach(function (node) {
        if (!node.atelierCarousel) return;
        node.atelierCarousel.destroy();
        node.atelierCarousel = null;
      });
      return;
    }

    loadFlickity().then(
      function (module) {
        nodes.forEach(function (node) {
          if (node.atelierCarousel) return;
          node.atelierCarousel = new module.Flickity(node, CAROUSEL_OPTIONS);
        });
      },
      function () {
        /* niente Flickity: restano gli scroller nativi del CSS */
      }
    );
  }

  // --------------------------------------------------------------------------
  // Form di prenotazione (Formful) — "sede appuntamento" gia scelta.
  //
  // Il form e un app block: le sue impostazioni non passano dal tema, quindi il
  // valore di partenza non si puo mettere di la. Lo mette questo blocco,
  // leggendo la sede che sections/apps.liquid ricava dal template della pagina
  // e stampa in data-atelier-form-location sulla sezione.
  //
  // Il campo si cerca prima per id Formful — gli stessi id del form "Atelier
  // Extended" (form_aZfXtaTanJ) su cui e appoggiato anche custom.css — e poi
  // per etichetta, cosi se in Formful il campo viene rifatto e l'id cambia la
  // ricerca regge lo stesso.
  //
  // Formful monta il form dopo il caricamento, quindi il primo tentativo quasi
  // sempre non trova niente: un MutationObserver riprova a ogni cambio del DOM
  // per venti secondi, il che copre anche il caso in cui l'app ridisegni il
  // campo subito dopo averlo montato.
  //
  // Il campo si tocca solo se e ancora vuoto, e comunque non piu di tre volte:
  // quello che sceglie chi compila non viene mai sovrascritto.
  // --------------------------------------------------------------------------
  var LOCATION_FIELD_ID = "I1RipYgfaO";
  var LOCATION_LABEL = /atelier|sede|location/;
  var LOCATION_TIMEOUT = 20000;
  var LOCATION_MAX_WRITES = 3;
  // Formful stampa il form gia nell'HTML, quindi il primo tentativo di solito
  // basta. Questi due ripassi coprono il caso in cui l'app ci rimetta mano
  // dopo (il campo porta un data-default che non corrisponde a nessuna voce).
  var LOCATION_RETRIES = [400, 1500];

  // "Remoto" e una voce del select come le citta: la consulenza a distanza.
  var LOCATION_ALIASES = {
    milano: ["milano", "milan", "\u30df\u30e9\u30ce"],
    roma: ["roma", "rome", "\u30ed\u30fc\u30de"],
    tokyo: ["tokyo", "tokio", "\u6771\u4eac"],
    remoto: ["remoto", "remote", "\u30ea\u30e2\u30fc\u30c8"]
  };

  function normalize(value) {
    var text = (value === null || value === undefined ? "" : String(value)).trim().toLowerCase();
    return text.normalize ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : text;
  }

  function matchesLocation(text, aliases) {
    var value = normalize(text);
    if (!value) return false;

    for (var i = 0; i < aliases.length; i++) {
      if (value.indexOf(aliases[i]) !== -1) return true;
    }
    return false;
  }

  // Il valore va scritto col setter del prototipo: i framework che pilotano il
  // campo tengono una copia del valore sull'elemento e, scrivendoci sopra
  // direttamente, non si accorgerebbero del cambio.
  function setFieldValue(element, value) {
    var descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(element), "value");

    if (descriptor && descriptor.set) {
      descriptor.set.call(element, value);
    } else {
      element.value = value;
    }

    element.dispatchEvent(new Event("input", { bubbles: true }));
    element.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function hasLocationOption(field, aliases) {
    var select = field.querySelector("select");
    if (!select) return false;

    for (var i = 0; i < select.options.length; i++) {
      if (matchesLocation(select.options[i].value, aliases)) return true;
    }
    return false;
  }

  // Sul form vero l'etichetta e "Atelier", non "sede": il fallback la cerca
  // larga, ma poi accetta il campo solo se ha davvero la voce della citta —
  // cosi non puo finire su un campo che non c'entra.
  function locationField(scope, aliases) {
    var field = scope.querySelector('[data-field-id="' + LOCATION_FIELD_ID + '"]');
    if (field) return field;

    var fields = scope.querySelectorAll("[data-field-id]");
    for (var i = 0; i < fields.length; i++) {
      var label = fields[i].querySelector(".formful__label, label");
      if (!label || !LOCATION_LABEL.test(normalize(label.textContent))) continue;
      if (hasLocationOption(fields[i], aliases)) return fields[i];
    }
    return null;
  }

  function selectLocationOption(select, aliases) {
    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];
      if (!normalize(option.value)) continue;
      if (matchesLocation(option.textContent, aliases) || matchesLocation(option.value, aliases)) {
        setFieldValue(select, option.value);
        return true;
      }
    }
    return false;
  }

  function applyFormLocation(scope, location) {
    if ((scope.atelierLocationWrites || 0) >= LOCATION_MAX_WRITES) return;

    var aliases = LOCATION_ALIASES[normalize(location)] || [normalize(location)];

    var field = locationField(scope, aliases);
    if (!field) return;

    var i;

    var select = field.querySelector("select");
    if (select) {
      if (normalize(select.value)) return;
      if (selectLocationOption(select, aliases)) {
        scope.atelierLocationWrites = (scope.atelierLocationWrites || 0) + 1;
      }
      return;
    }

    var boxes = field.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    if (boxes.length) {
      for (i = 0; i < boxes.length; i++) {
        if (boxes[i].checked) return;
      }

      for (i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        var wrapper = box.closest ? box.closest("label") : null;
        if (matchesLocation(wrapper ? wrapper.textContent : box.value, aliases)) {
          box.click();
          scope.atelierLocationWrites = (scope.atelierLocationWrites || 0) + 1;
          return;
        }
      }
      return;
    }

    var input = field.querySelector('input[type="text"], input:not([type])');
    if (input && !normalize(input.value)) {
      setFieldValue(input, location);
      scope.atelierLocationWrites = (scope.atelierLocationWrites || 0) + 1;
    }
  }

  function watchFormLocation(scope, location) {
    if (scope.atelierLocationWatcher || !window.MutationObserver) return;

    function stop() {
      observer.disconnect();
      scope.atelierLocationWatcher = null;
      clearTimeout(timer);
    }

    var observer = new MutationObserver(function () {
      applyFormLocation(scope, location);
    });

    var timer = setTimeout(stop, LOCATION_TIMEOUT);

    scope.atelierLocationWatcher = observer;
    observer.observe(scope, { childList: true, subtree: true });
  }

  function fillFormLocation(root) {
    var scopes = Array.prototype.slice.call(
      root.querySelectorAll ? root.querySelectorAll("[data-atelier-form-location]") : []
    );
    if (root.matches && root.matches("[data-atelier-form-location]")) scopes.push(root);

    scopes.forEach(function (scope) {
      var location = scope.getAttribute("data-atelier-form-location");
      if (!location) return;

      applyFormLocation(scope, location);
      watchFormLocation(scope, location);

      LOCATION_RETRIES.forEach(function (delay) {
        setTimeout(function () {
          applyFormLocation(scope, location);
        }, delay);
      });
    });
  }

  // --------------------------------------------------------------------------
  // Gli stessi campi, ma scelti dal bottone.
  //
  // Sulla pagina atelier i due CTA di Experience portano allo stesso form:
  // "in atelier" e "da remoto". Quale voce vada scelta lo dice l'impostazione
  // del blocco, che esce come data-form-location sul bottone.
  //
  // Qui la voce si scrive sempre, anche sopra a una gia presente: e un clic,
  // quindi e chi compila che ha chiesto di cambiarla. "page" rimette la sede
  // di partenza della pagina, che su una pagina senza sede vuol dire svuotare.
  // --------------------------------------------------------------------------
  function bookingFormScope(link) {
    var scope = document.querySelector(".atelier-booking-form");
    if (scope) return scope;

    var fields = document.querySelector(".formful__fields");
    scope = fields && fields.closest ? fields.closest(".section") : null;
    return scope || (link && link.closest ? link.closest("body") : null);
  }

  function applyLinkLocation(link) {
    var wanted = link.getAttribute("data-form-location");
    if (!wanted) return;

    var scope = bookingFormScope(link);
    if (!scope) return;

    if (normalize(wanted) === "page") {
      wanted = scope.getAttribute("data-atelier-form-location") || "";
    }

    var aliases = LOCATION_ALIASES[normalize(wanted)] || [normalize(wanted)];
    var field = locationField(scope, aliases);
    if (!field) return;

    var select = field.querySelector("select");
    if (!select) return;

    if (!normalize(wanted)) {
      setFieldValue(select, "");
      return;
    }

    selectLocationOption(select, aliases);
  }

  document.addEventListener("click", function (event) {
    var link = event.target && event.target.closest ? event.target.closest("[data-form-location]") : null;
    if (link) applyLinkLocation(link);
  });

  function init(root) {
    buildExperienceAccordion(root || document);
    fillFormLocation(root || document);
    syncCarousels();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Nell'editor tema le sezioni vengono ristampate: bottone e carosello vanno rimessi.
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  // Passando la soglia dei 60em il carosello va montato o smontato.
  var mobileQuery = window.matchMedia(MOBILE);
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", syncCarousels);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(syncCarousels);
  }
})();
